import { GET_USER_DATA_SUCCESS, REQUEST_BEGIN, REQUEST_FAILURE, RESET_USER_PROFILE, SET_USER_DATA_SUCCESS } from './users.types';

export const requestBegin = () => ({ type: REQUEST_BEGIN });
export const requestFailure = error => ({ type: REQUEST_FAILURE, payload: { error } });
export const getUserDataSuccess = user => ({ type: GET_USER_DATA_SUCCESS, payload: { user } });
export const setUserDataSuccess = () => ({ type: SET_USER_DATA_SUCCESS });
export const resetUserProfile = () => ({ type: RESET_USER_PROFILE });